module.exports = __webpack_public_path__ + "media/images/sp/top/keyword_waso_yoso-488fe47675c9bfd1be9e825e06dd5167.webp";